import React from 'react';
import { useLocation } from 'react-router-dom';
import { useUserSelector } from '../store/selectors/userSelector';
import { getPermissionInfo } from '../_common/functions';

interface EntityGuardProps {
    entity: string;
    children: React.ReactNode;
}

const AccessDenied: React.FC = () => (
    <div className="flex flex-col items-center justify-center h-full text-center">
        <div className="bg-white rounded-lg shadow-lg p-8 max-w-md">
            <svg className="mx-auto mb-4 h-16 w-16 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 48 48" aria-hidden="true">
                <circle cx="24" cy="24" r="22" strokeWidth="4" />
                <path strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" d="M16 16l16 16M32 16l-16 16" />
            </svg>
            <h1 className="text-2xl font-bold text-gray-800 mb-2">Access Denied</h1>
            <p className="text-gray-600 mb-6">
                You do not have permission to view this page.<br />
                Please contact your administrator if you believe this is an error.
            </p>
            <a href="/" className="inline-block px-6 py-2 bg-green-800 text-white rounded hover:bg-red-600 transition">
                Go to Home
            </a>
        </div>
    </div>
);

/**
 * Guards a page section behind an entity-level permission check.
 * Works for any module — pass the entity label exactly as it appears
 * in the UserModuleEntity table (e.g. "MTBF", "Asset Data Report").
 * Admin users (userTypeID === 1) always pass through.
 */
const EntityGuard: React.FC<EntityGuardProps> = ({ entity, children }) => {
    const loggedinuser: any = useUserSelector();
    const { pathname } = useLocation();

    if (!loggedinuser) return null;

    const hasAccess = getPermissionInfo(pathname, entity, loggedinuser);

    return hasAccess ? <>{children}</> : <AccessDenied />;
};

export default EntityGuard;
